(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay')) {
            this.header.classList.remove('color-background-overlay');
            this.header.classList.add('color-background-overlay-hidden');
          }
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');

          if (this.header.classList.contains('color-background-overlay-hidden')) {
            this.header.classList.add('color-background-overlay');
            this.header.classList.remove('color-background-overlay-hidden');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');

      if (this.header.classList.contains('color-background-overlay')) {
        this.header.classList.remove('color-background-overlay');
        this.header.classList.add('color-background-overlay-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

      if (this.header.classList.contains('color-background-overlay-hidden')) {
        const megaMenus = Array.from(document.querySelectorAll('.mega-menu'));
        if (megaMenus.some((megaMenu) => megaMenu.hasAttribute('open'))) return;
        this.header.classList.add('color-background-overlay');
        this.header.classList.remove('color-background-overlay-hidden');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (customElements.get('details-disclosure')) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }

      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      this.disclosureLists.forEach((disclosureList) => {
        disclosureList.setAttribute('hidden', true);
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.fullscreenSwiperBound = false;
    }

    hide() {
      this.pauseFullscreenVideos();
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);

      // Wait until the fullscreen modal / Swiper has updated
      requestAnimationFrame(() => {
        this.showActiveMedia();
        this.bindFullscreenSwiper();
      });
    }

    pauseFullscreenVideos() {
      this.querySelectorAll('.product-media-modal__item video').forEach((video) => {
        video.pause();
      });
    }

    playFullscreenSlide(slide) {
      if (!slide) return;

      // Pause every other fullscreen video first
      this.querySelectorAll('.product-media-modal__item video').forEach((video) => {
        if (!slide.contains(video)) {
          video.pause();
        }
      });

      const deferredMedia = slide.querySelector('deferred-media');

      // Create the actual video from the template if it has not loaded yet
      if (deferredMedia && !deferredMedia.hasAttribute('loaded')) {
        deferredMedia.loadContent();
      }

      requestAnimationFrame(() => {
        const video = slide.querySelector('video');

        if (!video) return;

        // Every time we arrive at the video:
        // restart from beginning + full sound
        video.pause();
        video.currentTime = 0;
        video.muted = false;
        video.volume = 1;

        const playPromise = video.play();

        if (playPromise !== undefined) {
          playPromise.catch(() => {
            // Browser autoplay protection may reject playback with sound.
          });
        }
      });
    }

    showActiveMedia() {
      const activeSlide = this.querySelector('.product-media-modal__item.swiper-slide-active');

      if (activeSlide) {
        this.playFullscreenSlide(activeSlide);
        return;
      }

      // Fallback when Swiper has not yet assigned swiper-slide-active
      if (this.openedBy) {
        const mediaId = this.openedBy.getAttribute('data-media-id');

        const matchingSlide = this.querySelector(`[data-media-modal-id="${mediaId}"]`);

        this.playFullscreenSlide(matchingSlide);
      }
    }

    bindFullscreenSwiper() {
      if (this.fullscreenSwiperBound) return;

      const slider = this.querySelector('.js-popup-slider');
      if (!slider) return;

      const bindSwiper = () => {
        if (!slider.swiper) {
          requestAnimationFrame(bindSwiper);
          return;
        }

        this.fullscreenSwiperBound = true;

        // As soon as the user starts leaving the video,
        // pause the current fullscreen video.
        slider.swiper.on('slideChangeTransitionStart', () => {
          this.pauseFullscreenVideos();
        });

        // When the new slide is reached, restart its video if it has one.
        slider.swiper.on('slideChangeTransitionEnd', () => {
          const activeSlide = this.querySelector('.product-media-modal__item.swiper-slide-active');

          this.playFullscreenSlide(activeSlide);
        });
      };

      bindSwiper();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
